import type { JSONSchema7 } from 'json-schema';

export type FoundryModelExcludeEntry = {
  name: string;
  /** When omitted or empty, every version of this model is excluded. */
  versions?: string[];
};

export type FoundryModelPickerUiOptions = {
  /** Optional. Omit or leave empty to show the full pinned-account catalog. */
  excludeModels?: FoundryModelExcludeEntry[];
};

export type FoundryModel = {
  name: string;
  version: string;
};

export type FoundryCatalogModel = {
  name: string;
  versions: string[];
};

export const FoundryModelPickerSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      excludeModels: {
        type: 'array',
        title: 'Excluded models',
        description:
          'Optional denylist. Omit or leave empty to show all models from the pinned Foundry catalog. A name with no versions excludes that model entirely; versions listed under a name are removed from the dropdown.',
        items: {
          type: 'object',
          required: ['name'],
          properties: {
            name: { type: 'string' },
            versions: {
              type: 'array',
              items: { type: 'string' },
            },
          },
        },
      },
    },
  } as JSONSchema7,
  returnValue: {
    title: 'Selected Foundry model',
    type: 'object',
    required: ['name', 'version'],
    properties: {
      name: { type: 'string' },
      version: { type: 'string' },
    },
  } as JSONSchema7,
};
